import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { AuthMethodsService } from '../auth-methods/auth-methods.service';
import { LoginProps } from './login.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage {
  @ViewChild('loginButton') loginButton?: any;
  @Input() title = 'login';

  private onLoginSubject = new Subject<{ login: NgForm, resendEmail: TemplateRef<any> }>();
  private resendEmailSubject = new Subject<void>();

  private _loginProps: LoginProps = {
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email',
    passwordRequired: 'Password is required',
    login: 'Login',
    signUp: 'Sign Up',
    forgotPassword: 'Forgot Password',
  }

  @Input() set loginProps(value: LoginProps) {
    this._loginProps = { ...this.loginProps, ...value };
  }

  get loginProps(): LoginProps {
    return this._loginProps;
  }

  constructor(
    readonly popoverController: PopoverController,
    private readonly authMethodsService: AuthMethodsService,
  ) {
    this.authMethodsService.translations?.subscribe(translations => {
      this.loginProps = { ...this.loginProps, ...translations.login || {} };
    });

    this.onLoginSubject.pipe(debounceTime(300)).subscribe(({ login, resendEmail }) => {
      this.authMethodsService.loginPageService?.onLogin(login, resendEmail);
    });

    this.resendEmailSubject.pipe(debounceTime(300)).subscribe(() => {
      this.authMethodsService.loginPageService?.resendEmailVerification();
    });

    this.onLogin = this.onLogin.bind(this);
    this.resendEmailVerification = this.resendEmailVerification.bind(this);
  }

  onLogin(login: NgForm, resendEmail: TemplateRef<any>): void {
    this.onLoginSubject.next({ login, resendEmail });
  }

  resendEmailVerification(): void {
    this.resendEmailSubject.next();
  }

  focusAndClickLoginButton(): void {
    if (this.loginButton) {
      this.loginButton.el?.click();
    }
  }
}